import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

/**
 * Tracks the currently expanded panel id so only one panel remains expanded at a time.
 */
@Injectable({ providedIn: 'root' })
export class ExpansionPanelGroupService {
  // Maintain a subject per group id. panels that share the same groupId will
  // participate in mutual-exclusive expansion. Panels without an explicit
  // group use the DEFAULT_GROUP.
  private readonly _groups = new Map<string, BehaviorSubject<string | null>>();

  active$(groupId: string): BehaviorSubject<string | null> {
    return this._getSubject(groupId);
  }

  setActive(groupId: string, panelId: string | null): void {
    this._getSubject(groupId).next(panelId);
  }

  private _getSubject(groupId: string): BehaviorSubject<string | null> {
    const id = groupId ?? ExpansionPanelGroupService.DEFAULT_GROUP;
    if (!this._groups.has(id)) {
      this._groups.set(id, new BehaviorSubject<string | null>(null));
    }
    return this._groups.get(id)!;
  }

  static readonly DEFAULT_GROUP = '__default__';
}
